import * as React from "react";

import { slide as Menu } from "react-burger-menu";

import { P1Nav } from "./Part1";
import { P2Nav } from "./Part2";
import { P3Nav } from "./Part3";

/* Note: Styles have been directly altered in the source library to include the following changes
    - menuWrap:
        - removal of the "right" property to help fix alignment issues (where the sidebar would stick out by default)
        - instead, left has been set to 0 to force correct alignment
        - margin has also been set to 0
    - itemList:
        - height:100% has been removed to fix issue where the list extends below the page (due to padding)
*/

export class Sidebar extends React.Component {
    showSettings (event: any) {
        event.preventDefault();
    }
    
    render () {
        return (
        <Menu pageWrapId={ "app" } outerContainerId={ "appContainer" }>
            <h1>Navigation</h1>
            <a id="sidebar-intro" className="menu-item introduction" href="#introduction">Introduction</a>
            <P1Nav/>
            <P2Nav/>
            <P3Nav/>
            <a id="sidebar-calc" className="menu-item endSection" href="#credits">Credits</a>
        </Menu>
        );
    }
}